import { type IIconsVector } from 'shared/ui/Icon/icons'
import { makeAutoObservableSuper } from 'shared/lib/mobx/makeAutoObservableSuper'
import { type IInboxKey } from 'entities/Inbox/model/types'
import { TYPES_INBOX } from 'entities/Inbox/store/types'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BaseInbox } from 'entities/Inbox/model/BaseInbox'
import { type IResponseSmartView } from 'entities/SmartViews/api/types'

export class SmartView extends BaseInbox<IResponseSmartView> {
  id: number
  is_favorite = false
  type: 'smart_view-inbox'
  teamsIds: number[] = []
  root_tree = ''
  name = ''
  isMuted = false
  isPFTInbox = false
  color_coding_enabled = false
  unread = 0
  unread_calls = 0
  filters: IResponseSmartView['filters'] = []
  origin!: IResponseSmartView

  constructor(item: IResponseSmartView, private _entities: IEntitiesStore) {
    super(item)

    this.id = item.id
    this.type = 'smart_view-inbox'
    this.syncOrigin(item)

    makeAutoObservableSuper(this)
  }

  syncOrigin = (origin: IResponseSmartView & { root_tree?: string }) => {
    this.id = origin.id
    this.is_favorite = origin.is_favorite
    this.name = origin.name
    this.root_tree = origin.root_tree || this.initRootTree()
    this.unread = origin.unread_count || 0
    this.filters = origin.filters
    this.origin = origin
  }

  setUnread = (value: number) => {
    this.unread = value

    if (this.unread <= 0) this.unread = 0
  }

  get unreadCount() {
    return this.unread
  }

  get isCreateGroup() {
    return false
  }

  get icon(): IIconsVector {
    return 'filter'
  }

  get inboxType() {
    return TYPES_INBOX.UNIFIED
  }

  get typeKey(): IInboxKey {
    return 'smart_view'
  }

  get bodyUpdateUserTeam() {
    return {
      id: this.id,
      type: this.inboxType,
    }
  }

  get bodyUpdateTeamsGroupsById() {
    return {
      name: this.name,
      description: '',
      team_ids: [],
    }
  }

  get idTree() {
    return `${this.root_tree}_${this.id}`
  }
}
